import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchPublisherPublicCatalogLink } from "../api/publicCatalogService";
/**
 * Public catalog link of a publisher (DB-801), read from its agency copy. `null` while loading,
 * when the agency has no copy of the publisher, and when the read fails: the link is an optional
 * addition to the detail, so a failure only leaves it out (and is logged) instead of breaking the
 * page.
 *
 * @param publisherId the publisher id; no request is made without it
 */
export var usePublisherPublicCatalogLink = function (publisherId) {
    var ky = useOkapiKy();
    var data = useQuery(["publisher-public-catalog-link", publisherId], function () { return fetchPublisherPublicCatalogLink(ky, publisherId); }, {
        enabled: !!publisherId,
        retry: false,
        onError: function (error) {
            console.error("Failed to load the public catalog link of the publisher:", error);
        },
    }).data;
    return data !== null && data !== void 0 ? data : null;
};
